export default {
    topics: [
        {
            title: ' CalcBudgetCategoryTotal ',
            href: 'sm-budget-CalcBudgetCategoryTotal.html',
            attributes: { 'data-id': 'sm-budget-CalcBudgetCategoryTotal' },
            menu: { hasChildren: false },
            tocID: 'sm-budget-CalcBudgetCategoryTotal-d66e2191',
            topics: [],
        },
        {
            title: ' CalcCostVentilationTotal ',
            href: 'sm-budget-CalcCostVentilationTotal.html',
            attributes: { 'data-id': 'sm-budget-CalcCostVentilationTotal' },
            menu: { hasChildren: false },
            tocID: 'sm-budget-CalcCostVentilationTotal-d66e2199',
            topics: [],
        },
        {
            title: ' ComputationExpenseLine ',
            href: 'sm-budget-ComputationExpenseLine.html',
            attributes: { 'data-id': 'sm-budget-ComputationExpenseLine' },
            menu: { hasChildren: false },
            tocID: 'sm-budget-ComputationExpenseLine-d66e2207',
            topics: [],
        },
        {
            title: ' ForceBudgetCalculation ',
            href: 'sm-budget-ForceBudgetCalculation.html',
            attributes: { 'data-id': 'sm-budget-ForceBudgetCalculation' },
            menu: { hasChildren: false },
            tocID: 'sm-budget-ForceBudgetCalculation-d66e2215',
            topics: [],
        },
        {
            title: ' UpdateInvoice ',
            href: 'sm-budget-UpdateInvoice.html',
            attributes: { 'data-id': 'sm-budget-UpdateInvoice' },
            menu: { hasChildren: false },
            tocID: 'sm-budget-UpdateInvoice-d66e2223',
            topics: [],
        },
        {
            title: ' UpdateRealCostFromExpenseLine ',
            href: 'sm-budget-UpdateRealCostFromExpenseLine.html',
            attributes: { 'data-id': 'sm-budget-UpdateRealCostFromExpenseLine' },
            menu: { hasChildren: false },
            tocID: 'sm-budget-UpdateRealCostFromExpenseLine-d66e2231',
            topics: [],
        },
    ],
};

